export function historyFunctions(){

  // 特定の要素から次の要素までsection で囲む
    $(function () {
      // h2から次のh2の間をsectionで囲む
      $(".epoc_event").each(function (i) {

        $(this)
          .nextUntil(".epoc_event")
          .add(this)
          .wrapAll("<section></section>");
      });


    });

    let set_position = [];
    let epoc_event = $(".epoc_event");
    epoc_event.each(function(elm){
      console.log($(this).attr("id"), $(this).position().top);
      let obj = {
        "id": $(this).attr("id"),
        "top": $(this).position().top
      }
      set_position.push(obj);
    })



    // console.log(set_position)


    $(window).on("load scroll",function(){
      let window_scrollTop = $(window).scrollTop();
      // let window_top = $(window).top();

      // console.log($(epoc_event[0]).position().top, set_position);
      // console.log(window_scrollTop)

 for (let i = 0; i < set_position.length; i++) {
  const element = set_position[i];
  if (window_scrollTop >= element.top ){
    // console.log(element.id)
    // $("#" + element.id).css('background-color',"red")
    $("#" + element.id).addClass('addGrad');
  } else {
    // $("#" + element.id).css("background-color", "transparent");
    $("#" + element.id).removeClass("addGrad");
  }
 }


      // epoc_event.each(function(elm){
      //   if ($(this).position().top <= window_scrollTop){
      //     console.log("stop :", $(this).position().top, $(this).attr("id"));
      //   }
      //     // console.log();
      //         console.log(window_scrollTop);
      // }
      // )

    })


    // $(".year_ac").each(function(index,elment){
    //   console.log(elment.innerText)
    // })



    // スクロールで class を付与
    $(window).on('scroll load',function(){

      let elm = $(".history__chronology__head");
        let scrollPos = $(window).scrollTop();
        let wh = $(window).height();
      
      elm.each(function(){
        let elm_offset = $(this).offset().top;

        if(scrollPos > elm_offset - wh + (wh / 3) ){
          $(this).addClass("isAction")
        }
      })

      // 最後の項目が表示されたら
      let ani100year = $("#hisotry_2032");
      let epoc_label = $('.epoc_event')

      if(ani100year.length != 0){

              if (scrollPos > ani100year.offset().top - wh + wh / 3) {
                epoc_label.fadeOut();
              } else if (scrollPos < ani100year.offset().top - wh + wh / 3) {
                epoc_label.fadeIn();
              }
      }





      // 画像の動き
      let content_body = $('.history__chronology__body')

      content_body.each(function () {
        let content_body_offset = $(this).offset().top

        if (scrollPos > content_body_offset - wh + wh / 3) {
          $(this).addClass("isAction");
        }
      });

    })


}

